<template>
    <page :showDashboardButton="true">
        <!-- <template v-slot:header>
      <ion-title>Login</ion-title>
    </template> -->
        <ion-grid class="grid" style="padding: 0 10vw;">
            <ion-row class="row">
                <!--ion-align-items-center-->

                <!-- </ion-row>

      <ion-row> -->
                <ion-col size="12" class="ion-align-self-center">
                    <!-- <h1>Login</h1> -->
                    <!-- <span
            class="icon-kamel"
            style="font-size: 70px; color: #ed2a24;"
          ></span> -->
                    <div class="c-login-klickmallogo">
                        <svg
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 305.4 69.6"
                            style="enable-background: new 0 0 305.4 69.6;"
                            xml:space="preserve"
                        >
                            <g>
                                <polygon
                                    points="301.6,54.6 305.4,54.6 305.4,10.4 301.6,10.4 	"
                                />
                                <path
                                    d="M292,54.6c-0.2-0.5-0.4-1.2-0.5-1.9s-0.2-1.6-0.2-2.6V34.5c0-3-1-5.5-2.9-7.4s-4.6-2.8-8.2-2.8c-1.4,0-2.8,0.2-4.1,0.6
		s-2.5,0.9-3.5,1.7c-1,0.8-1.9,1.7-2.6,2.8c-0.7,1.1-1.1,2.4-1.3,3.9l3.9,0.6c0.2-1.9,0.9-3.4,2-4.6c1.2-1.2,3-1.8,5.5-1.8
		c2.6,0,4.5,0.7,5.7,2.1s1.8,3.2,1.8,5.4v2.3c-2.7,0-5.2,0.2-7.7,0.5c-2.4,0.3-4.5,0.9-6.3,1.7s-3.3,1.8-4.3,3.1
		c-1.1,1.3-1.6,2.9-1.6,4.8c0,2.6,0.8,4.6,2.5,6c1.7,1.5,3.9,2.2,6.8,2.2c2.6,0,4.8-0.5,6.7-1.6c1.8-1.1,3.1-2.2,3.9-3.5
		c0,1,0,1.8,0.2,2.6c0.1,0.8,0.3,1.4,0.5,1.7h3.7V54.6z M287.6,42.9c0,1.5-0.3,2.9-0.8,4c-0.5,1.2-1.3,2.1-2.2,3
		c-0.9,0.8-2,1.4-3.2,1.9c-1.2,0.4-2.5,0.6-3.8,0.6c-1.9,0-3.4-0.5-4.5-1.5s-1.7-2.3-1.7-3.9c0-1.2,0.4-2.3,1.2-3.1
		c0.8-0.9,1.9-1.6,3.3-2.1c1.4-0.6,3.1-1,5.1-1.2c2-0.3,4.1-0.4,6.5-0.4v2.7H287.6z"
                                />
                                <path
                                    d="M237.3,35.1v19.5h3.8V37.2c0-1.4,0.2-2.7,0.7-3.9s1.1-2.2,1.9-3.1c0.8-0.9,1.7-1.6,2.7-2.1s2.1-0.7,3.2-0.7
		c1.9,0,3.4,0.6,4.6,1.9c1.2,1.3,1.9,3.2,1.9,5.7v19.6h3.8V34.3c0-1.7-0.2-3.2-0.7-4.4c-0.5-1.3-1.2-2.3-2-3.2
		c-0.9-0.8-1.9-1.5-3-1.9c-1.2-0.4-2.4-0.6-3.8-0.6c-2.5,0-4.5,0.5-6.1,1.6s-2.9,2.4-3.8,4c-0.7-1.9-1.9-3.3-3.4-4.2
		c-1.6-0.9-3.3-1.4-5.4-1.4c-2.4,0-4.4,0.6-6,1.7s-2.8,2.5-3.5,4V25h-3.5v29.6h3.8v-17c0-1.5,0.2-2.8,0.7-4.1
		c0.4-1.2,1.1-2.3,1.8-3.2c0.8-0.9,1.7-1.6,2.7-2.1s2.1-0.8,3.2-0.8c1.9,0,3.4,0.6,4.6,1.9C236.7,30.6,237.3,32.5,237.3,35.1
		L237.3,35.1L237.3,35.1z"
                                />
                                <polygon
                                    points="193.2,40.1 203.4,54.6 211.9,54.6 198.4,35.7 210.2,24.7 201.8,24.7 190.2,35.4 190.2,10.4 183,10.4 183,54.6 
		190.2,54.6 190.2,42.9 	"
                                />
                                <path
                                    d="M149.2,39.6c0,2.4,0.3,4.6,1,6.5s1.7,3.6,3,5s2.8,2.4,4.6,3.2s3.8,1.1,6.1,1.1c1.7,0,3.2-0.2,4.5-0.6
		c1.3-0.4,2.5-1,3.5-1.7s1.9-1.6,2.7-2.5c0.8-1,1.5-2,2.1-3.1l-6.6-2.5c-0.5,1.3-1.3,2.5-2.2,3.4s-2.2,1.4-4,1.4
		c-1.3,0-2.4-0.3-3.3-0.9c-0.9-0.6-1.7-1.3-2.2-2.3c-0.6-0.9-1-2-1.3-3.2s-0.4-2.5-0.4-3.8s0.1-2.6,0.4-3.8c0.3-1.2,0.7-2.3,1.3-3.2
		s1.3-1.7,2.2-2.2c0.9-0.6,2-0.9,3.3-0.9c1.7,0,3,0.5,4.1,1.4c1,0.9,1.8,2.2,2.2,3.8l6.5-2.5c-0.5-1.2-1.1-2.3-1.8-3.3
		s-1.5-1.9-2.6-2.6c-1-0.7-2.2-1.3-3.5-1.7c-1.3-0.4-2.8-0.6-4.6-0.6c-2.3,0-4.4,0.4-6.2,1.1c-1.8,0.8-3.4,1.8-4.7,3.2
		c-1.3,1.4-2.3,3-3,5C149.6,35.1,149.2,37.3,149.2,39.6L149.2,39.6L149.2,39.6z"
                                />
                                <polygon
                                    points="118.7,54.6 125.9,54.6 125.9,10.4 118.7,10.4 	"
                                />
                                <polygon
                                    points="95.3,40.1 105.4,54.6 113.9,54.6 100.4,35.7 112.2,24.7 103.8,24.7 92.2,35.4 92.2,10.4 85,10.4 85,54.6 
		92.2,54.6 92.2,42.9 	"
                                />
                                <polygon
                                    points="135,54.6 142.2,54.6 142.2,24.7 135,24.7 	"
                                />
                                <path
                                    d="M134.2,64.8c0,1.2,0.4,2.3,1.2,3.1c0.8,0.8,1.9,1.3,3.2,1.3s2.4-0.4,3.2-1.3c0.8-0.8,1.2-1.9,1.2-3.1
		c0-1.3-0.4-2.4-1.2-3.2s-1.9-1.2-3.2-1.2s-2.4,0.4-3.2,1.2S134.2,63.5,134.2,64.8L134.2,64.8L134.2,64.8z"
                                />
                                <g>
                                    <path
                                        d="M69.6,34.8c0,19.4-15.7,34.8-34.8,34.8C15.7,69.6,0.1,54,0,34.8C0,15.6,15.6,0,34.8,0C54,0,69.6,15.5,69.6,34.8z
			M35.7,48.9c0-0.1,0-0.2,0-0.2c0.4-2,0.7-4,1.2-6c0.2-1.1,0.2-2-0.4-3c-0.3-0.4-0.5-0.8-0.6-1.2c-0.8-2.2-1.6-4.4-2.4-6.6
			c-0.1-0.3,0-0.4,0.2-0.4c0.8-0.3,1.7-0.6,2.5-0.9c0.2-0.1,0.4,0,0.5,0.2c0.7,0.7,1.4,1.4,2.2,2c1,0.8,2.2,1.3,3.6,1.4
			c1.9,0.1,3.3-0.7,4.5-2.1c0.8-0.9,1.3-1.9,1.7-3c0.6-1.5,1-3.1,1.3-4.7c0-0.1,0.1-0.2,0.2-0.2c0.9-0.1,1.5-0.6,2.2-1
			c0.2-0.1,0.4-0.3,0.7-0.4c0.6-0.2,1,0.1,1,0.7c0,0.3,0,0.6,0,0.9c0.1,0.7,0.3,0.9,1,1c0.4,0,0.6-0.1,0.7-0.4c0.1-0.3,0.1-0.7,0-1
			c0-0.3-0.1-0.6-0.1-1c0,0,0.1,0,0.1,0c0.2,0.4,0.5,0.8,0.7,1.2c0.4,0.7,1,0.7,1.6,0.2c0.1-0.1,0.2-0.2,0.2-0.3
			c0.8-1.2,0.8-2.6,0-3.9c-0.6-0.9-1.3-1.5-2.4-1.7c-0.6-0.1-1.1-0.1-1.7-0.2c-0.6-0.1-1.2-0.1-1.7-0.2c-0.5-0.1-0.7-0.5-1-1
			c0.2,0,0.3,0,0.5,0c0,0,0,0,0-0.1c-0.3-0.2-0.7-0.5-1-0.7c0,0,0,0,0-0.1c0.2,0,0.4,0,0.6,0.1c0,0,0,0,0-0.1
			c-0.1-0.1-0.3-0.2-0.5-0.3c0.3,0,0.4,0,0.7,0c-0.1-0.1-0.2-0.1-0.2-0.1c-0.4-0.1-0.8-0.2-1.2-0.3c0,0,0-0.1,0.1-0.2
			c-0.6,0.1-1.1,0.2-1.6,0.2c0,0,0,0,0,0c0.2-0.2,0.5-0.3,0.7-0.5c-0.1,0-0.2,0-0.2,0c-0.4,0.2-0.8,0.4-1.2,0.6
			c-0.1,0.1-0.3,0.1-0.4,0.1c0.1-0.2,0.1-0.2,0.2-0.3c-0.3,0.1-0.4,0.4-0.7,0.3c-0.1,0-0.4,0.3-0.4,0.5c-0.2,0.5-0.6,0.8-1.1,0.8
			c-0.3,0-0.4,0.2-0.4,0.5c0,0.2,0,0.4,0.1,0.7c0,0.2,0,0.3-0.2,0.4c-0.1,0-0.2,0.2-0.1,0.3c0.1,0.6,0.3,1.2,0.9,1.5
			c0,0.2,0,0.3-0.1,0.4c-0.3,2-0.7,4-1,5.9c-0.1,0.8-0.3,1.6-0.7,2.3c-0.3,0.6-0.8,0.9-1.5,0.9c-1.1,0-2-0.5-2.8-1.4
			c-0.9-1.1-1.5-2.3-2-3.6c-0.3-0.9-0.8-1.7-1.3-2.5c-0.6-0.8-1.1-1.6-1.6-2.4c-0.4-0.6-0.7-1.3-1-2c-0.4-0.7-0.8-1.4-1.3-2
			c-0.7-0.9-1.5-1.1-2.6-0.5c-0.5,0.3-1,0.7-1.5,1.1c-0.4,0.4-0.8,0.8-1.2,1.2c-0.1,0-0.1-0.1-0.2-0.1c-0.8-0.8-1.8-0.6-2.5,0
			c-0.5,0.4-0.9,1-1.2,1.6c-0.7,1.5-1.6,2.9-2.9,4c-1.1,0.9-1.7,2.1-2,3.5c-0.3,1.4-0.5,2.9-0.7,4.3c-0.2,1.3-0.2,2.5-0.6,3.8
			c-0.5,1.4-0.2,2.7,0.3,4.1c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.3,0-0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1-0.6-0.1-1.2,0.2-1.8
			c0.1,0.3,0.1,0.7,0.2,1c0,0,0.1,0,0.1,0c0-0.2,0.1-0.4,0.1-0.6c0-0.8,0-1.6,0-2.4c-0.1-1.4-0.2-2.8-0.1-4.2c0-0.3,0.1-0.6,0.1-1
			c0.1-0.3,0.1-0.6,0.2-0.9c0.1,2.5,0.4,5,0.7,7.4c0.1,0.9,0.2,1.8-0.3,2.6c-0.5,0.8-1,1.6-1.5,2.4c-1.3,2.1-2.7,4.1-4.4,5.9
			c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4,0.1-0.5,0.3c-0.5,0.7-0.9,1.5-1.4,2.2c0,0.1-0.1,0.1-0.2,0.2c-0.4,0.4-0.4,0.5,0.1,0.9
			c1.6,1.2,3.3,2.1,5.2,2.6c0.3,0.1,0.7,0.1,1.1,0.1c0.2,0,0.4-0.2,0.5-0.4c0.1-0.2,0-0.5-0.2-0.6c-0.2-0.2-0.4-0.4-0.7-0.5
			c-0.7-0.3-1.1-0.9-1.5-1.5c-0.2-0.4-0.3-0.8-0.2-1.2c0.1-0.2,0.1-0.5,0.2-0.8c0.1-0.4,0-0.7-0.4-0.9c0,0,0-0.1,0.1-0.1
			c1.5-2.5,3.3-4.7,5.3-6.8c0.6-0.6,0.9-1.3,1-2.1c0.1-0.8,0.4-1.6,0.6-2.3c0,0,0.1,0,0.1,0c0.4,0.9,0.8,1.8,1.2,2.6
			c0.2,0.5,0.2,0.9,0,1.3c-0.3,0.8-0.7,1.6-1,2.5c-0.8,2.7-2,5.3-3.3,7.8c-0.1,0.1-0.1,0.3-0.2,0.3c-0.4,0-0.5,0.3-0.5,0.6
			c-0.1,1-0.3,2-0.5,3c-0.1,0.6,0,0.6,0.5,0.7c0.2,0.1,0.4,0.1,0.7,0.2c1.5,0.3,3,0.4,4.4,0.2c1-0.1,1.9-0.3,2.8-0.8
			c-0.1-0.1-0.1-0.3-0.2-0.5c0.1,0,0.2,0,0.4,0c1.2,0,2.3,0,3.5,0c0.4,0,0.7-0.1,1.1-0.1c0.4-0.1,0.4-0.3,0.2-0.6
			c-0.1-0.2-0.3-0.4-0.6-0.6c-0.3-0.2-0.7-0.4-1-0.5c-0.6-0.3-1.3-0.5-2-0.8c-0.4-0.2-0.7-0.4-1-0.6c-0.2-0.1-0.2-0.3-0.1-0.5
			c0.2-0.6,0-0.8-0.6-1c0,0,0,0-0.1-0.1c0.1-0.3,0.1-0.5,0.2-0.7c0.5-1.8,1-3.6,1.7-5.3c0.3-0.8,0.5-1.7,0.8-2.5
			c0.2-0.7,0.4-1.4,0.7-2.1c0.4-0.9,0.9-1.8,1.3-2.7c0.2-0.3,0.3-0.6,0.5-1c0.1,0.1,0.1,0.2,0.2,0.2c1,1.3,2.1,2.6,3.1,4
			c0.8,1.1,1.1,2.5,1.1,3.8c-0.1,2.2-0.6,4.4-1.3,6.5c0,0.1-0.1,0.2-0.1,0.2c-0.4,0.1-0.4,0.4-0.4,0.7c-0.2,1.1-0.2,2.2,0,3.4
			c0,0.1,0.1,0.3,0.2,0.3c0.4,0.2,0.8,0.3,1.2,0.2c2.1-0.2,4.1-0.7,5.9-1.6c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.3,0.3-0.5-0.1-0.7
			c-0.1,0-0.2-0.1-0.3-0.1c-0.5,0-0.9-0.1-1.4-0.1c-0.9,0-1.8-0.1-2.7-0.4c-0.4-0.1-0.6-0.3-0.7-0.7C36.3,48.9,36.3,48.9,35.7,48.9z
			"
                                    />
                                    <path
                                        class="st0"
                                        d="M24.4,29.7C24.4,29.7,24.4,29.7,24.4,29.7c0,0.4,0,0.7,0,1c0.3,2.9,0.5,5.9,0.8,8.8c0,0.5,0,0.9-0.3,1.3
			c-0.2,0.4-0.4,0.7-0.6,1.1c-0.6,1-1.2,2.1-1.7,3.2c-0.6,1.5-1.2,3-1.8,4.5c-0.1,0.2-0.1,0.3-0.2,0.5c0.5,0,0.7,0.3,0.9,0.7
			c0.2,0.4,0.4,0.7,0.6,1.1c0.1,0.2,0.3,0.3,0.5,0.6c0.1-0.5,0.1-1,0.2-1.4c0.1-0.4,0.3-0.9,0.4-1.3c0.1-0.2,0.2-0.4,0.5-0.4
			c0.1,0,0.1-0.1,0.2-0.2c0.9-1.6,1.4-3.4,1.8-5.1c0.3-1.6,0.7-3.1,1.5-4.5c0.2-0.4,0.3-0.8,0.4-1.2c0.4-1.8,0.6-3.7,0.8-5.6
			c0-0.3-0.1-0.3-0.3-0.4c-1.3-0.5-2.5-1.1-3.4-2.1C24.6,30,24.5,29.9,24.4,29.7z M50.9,19.5c0.2,0.4,0.5,0.5,0.9,0.5
			c0.3-0.1,0.6-0.4,0.7-0.9c0-0.3-0.2-0.6-0.4-0.7c-0.4-0.1-0.8,0-1,0.2c0.3,0,0.6-0.1,0.7,0.3c0,0.2,0,0.4-0.1,0.6
			C51.5,19.7,51.2,19.6,50.9,19.5z"
                                    />
                                    <path
                                        d="M24.4,29.7c0.1,0.1,0.2,0.3,0.3,0.4c0.9,1.1,2.1,1.7,3.4,2.1c0.2,0.1,0.3,0.2,0.3,0.4c-0.2,1.9-0.3,3.8-0.8,5.6
			c-0.1,0.4-0.2,0.8-0.4,1.2c-0.8,1.4-1.2,3-1.5,4.5c-0.4,1.8-0.9,3.5-1.8,5.1c0,0.1-0.1,0.1-0.2,0.2c-0.3,0-0.4,0.2-0.5,0.4
			c-0.1,0.4-0.3,0.9-0.4,1.3c-0.1,0.4-0.1,0.9-0.2,1.4c-0.2-0.2-0.4-0.4-0.5-0.6c-0.2-0.3-0.4-0.7-0.6-1.1c-0.2-0.4-0.3-0.7-0.9-0.7
			c0.1-0.2,0.1-0.4,0.2-0.5c0.6-1.5,1.1-3,1.8-4.5c0.5-1.1,1.1-2.1,1.7-3.2c0.2-0.4,0.4-0.7,0.6-1.1c0.2-0.4,0.3-0.9,0.3-1.3
			c-0.3-2.9-0.6-5.9-0.8-8.8C24.4,30.4,24.4,30.1,24.4,29.7C24.4,29.7,24.4,29.7,24.4,29.7z"
                                    />
                                    <path
                                        d="M50.9,19.5c0.3,0.1,0.5,0.2,0.7-0.1c0.1-0.1,0.1-0.4,0.1-0.6c-0.1-0.4-0.4-0.3-0.7-0.3c0.2-0.3,0.7-0.4,1-0.2
			c0.2,0.1,0.4,0.4,0.4,0.7c0,0.5-0.3,0.8-0.7,0.9C51.4,20,51.1,19.9,50.9,19.5z"
                                    />
                                </g>
                            </g>
                        </svg>
                    </div>
                </ion-col>
                <ion-col size="12">
                    <form @submit.prevent="login()">
                        <ion-row>
                            <ion-col size="12">
                                <base-input
                                    label="Verfügernummer"
                                    v-model="user"
                                    type="number"
                                    id="verfuegernummer"
                                    @keyup.enter.native="login()"
                                ></base-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col size="12">
                                <base-input
                                    label="Passwort"
                                    v-model="password"
                                    type="password"
                                    id="passwort"
                                    @keyup.enter.native="login()"
                                ></base-input>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col>
                                <a
                                    class="u-size-small"
                                    href="#"
                                    @click.prevent="
                                        Browser.open({
                                            url:
                                                'https://www.wuestenrot.at/de/eservices-formulare/passwort-vergessen.html',
                                        })
                                    "
                                    >Passwort vergessen?</a
                                >
                            </ion-col>
                        </ion-row>
                        <ion-row class="ion-align-items-center">
                            <ion-col>
                                <ion-button expand="block" @click="login()">
                                    Login
                                </ion-button>
                            </ion-col>
                            <ion-col
                                size="auto"
                                class="ion-text-center"
                                v-if="isFingerprintVisible || isFaceIdVisible"
                            >
                                <ion-button
                                    @click="verifyFingerprint()"
                                    color="primary"
                                    fill="clear"
                                    size="large"
                                >
                                    <ion-icon
                                        name="finger-print"
                                        size="large"
                                        slot="icon-only"
                                        v-if="isFingerprintVisible"
                                    ></ion-icon>
                                    <span
                                        class="icon-faceid u-size-x-large u-weight-bold"
                                        slot="icon-only"
                                        v-else-if="isFaceIdVisible"
                                    ></span>
                                </ion-button>
                            </ion-col>
                        </ion-row>
                        <ion-row class="ion-margin-top">
                            <ion-col class="u-size-small ion-text-center">
                                <b>Noch kein Konto?</b>
                            </ion-col>
                        </ion-row>
                        <ion-row>
                            <ion-col class="u-size-small ion-text-center">
                                <div>
                                    <a
                                        href="#"
                                        @click.prevent="
                                            Browser.open({
                                                url:
                                                    'https://www.wuestenrot.at/de/eservices-formulare/registrierung.html',
                                            })
                                        "
                                        >Jetzt registrieren</a
                                    >
                                </div>
                                <div size="12">oder</div>
                                <div size="12">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            $router.push({
                                                name: 'aktivierung',
                                            })
                                        "
                                        >Aktivierungscode einlösen</a
                                    >
                                </div>
                            </ion-col>
                        </ion-row>
                        <!-- <ion-row>
              <ion-col>
                <b>Noch kein Login? </b><br>
                <router-link to="/dashboard">Hier kannst du die App ausprobieren.</router-link>

                <img
                  src="../assets/img/kamel_sprech_linie.png"
                  class="c-kamel-sprechblase"
                >

              </ion-col>
            </ion-row> -->
                    </form>
                </ion-col>

                <ion-col size="12" class="ion-text-center ion-align-self-end">
                    <img
                        src="../assets/img/wuestenrot_logo.svg"
                        class="c-login-logo"
                    />
                </ion-col>
            </ion-row>
        </ion-grid>
    </page>
</template>

<script>
import Page from "@/components/Page";
import { login } from "@/api/auth";
import { FingerprintAIO } from "@ionic-native/fingerprint-aio";
import "capacitor-secure-storage-plugin";
import { Plugins } from "@capacitor/core";
import BaseInput from "@/components/BaseInput";
import { handleError } from "@/utils/error";
import { setEnvironment } from "@/utils/environment";

const { SecureStoragePlugin, Storage } = Plugins;

export default {
    components: {
        Page,
        BaseInput,
    },
    data() {
        return {
            user: "",
            password: "",
            faio: FingerprintAIO,
            isFaceIdVisible: false,
            isFingerprintVisible: false,
            Browser: Plugins.Browser,
        };
    },
    mounted() {
        Storage.get({ key: "usernumber" }).then(({ value: val }) => {
            if (val !== null) {
                this.user = val;
                Storage.get({ key: "fingerprint" }).then(({ value: val }) => {
                    if (val !== "false") {
                        SecureStoragePlugin.get({ key: this.user })
                            .then((result) => {
                                // eslint-disable-next-line
                                if (result.value !== "ée") {
                                    this.faio
                                        .isAvailable()
                                        .then((result) => {
                                            if (result === "face") {
                                                this.isFaceIdVisible = true;
                                            } else if (result === "finger") {
                                                this.isFingerprintVisible = true;
                                                this.verifyFingerprint();
                                            }
                                        })
                                        .catch((error) => handleError(error));
                                }
                            })
                            .catch((error) => {
                                handleError(error);
                            });
                    }
                });
            }
        });
    },
    methods: {
        login() {
            if (this.user === "1234567890") {
                setEnvironment(this.password);
            } else {
                this.$store.commit("setLoadingSpinnerDuration", 60 * 1000);
                this.$store.commit("setLoading", true);
                login(this.user, this.password, true).then(() => {
                    this.$store.commit("setLoadingSpinnerDuration", 20 * 1000);
                    Storage.remove({
                        key: "hideVoucher",
                    });
                });
            }
        },
        verifyFingerprint: function () {
            this.faio
                .show({
                    clientId: "Fingerprint-Wuestenrot", //Android: Used for encryption. iOS: used for dialogue if no `localizedReason` is given.
                    clientSecret: "qJ#HBa62}qy]m#p<kqxL", //Necessary for Android encrpytion of keys. Use random secret key.
                    disableBackup: true, //Only for Android(optional)
                    localizedFallbackTitle: "Pin benutzen", //Only for iOS
                    localizedReason: "Bitte authentifizieren", //Only for iOS
                })
                .then(() => {
                    // console.log(result);
                    // console.log(this.user);
                    SecureStoragePlugin.get({ key: this.user })
                        .then((result) => {
                            // console.log(result.value);
                            // eslint-disable-next-line
                            if (result.value !== "ée") {
                                this.password = result.value;
                                this.login();
                            } else {
                                this.$ionic.alertController
                                    .create({
                                        header: "Bitte beachten",
                                        message:
                                            "Für die Verfügernummer " +
                                            this.user +
                                            " wurde kein verknüpftes Passwort gefunden. Bitte logge dich manuell ein.",
                                        buttons: ["OK"],
                                    })
                                    .then((a) => {
                                        a.present();
                                    });
                            }
                        })
                        .catch((error) => {
                            // console.log("Item with specified key does not exist.");
                            handleError(error);
                        });
                })
                .catch((error) => handleError(error));
        },
    },
};
</script>

<style scoped lang="scss">
.row,
.grid {
    height: 100%;
}

.c-login-logo {
    // margin-left: -16px;
    // margin-bottom: var(--gangl-padding-large);
    width: 120px;
}

.c-login-klickmallogo {
    width: 200px;
    margin: auto;
}

.c-kamel-sprechblase {
    // padding: absolute;
    // bottom: -20px;
    // right: 0;
}
</style>

<style lang="scss">
body.dark .c-login-klickmallogo svg {
    fill: white;
}
</style>
